/**
 * @description List of locales supported by the library, for compile time checks.
 */
export const DefaultLocales = [
  "ar",
  "bg",
  "bn-IN",
  "cs",
  "da",
  "de",
  "el",
  "en-GB",
  "en-US",
  "es-ES",
  "es",
  "et",
  "fa",
  "fi",
  "fr-CA",
  "fr",
  "ga",
  "hi-IN",
  "hr",
  "hu",
  "id",
  "is",
  "it",
  "iw",
  "ja",
  "kk",
  "ko",
  "lo",
  "lt",
  "lv",
  "ms",
  "nl",
  "nl-BE",
  "no",
  "pl",
  "pt-BR",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sv",
  "sw",
  "ta",
  "tl",
  "uk",
  "ur",
  "vi",
  "th",
  "tr",
  "zh-HK",
  "zh",
  "zu",
] as const;

/**
 * @description Mutable list of locales supported by the library, for runtime checks.
 */
export const Locales = [...DefaultLocales];
